import { render, staticRenderFns } from "./ArchivoPacienteDetalles.vue?vue&type=template&id=627bcc22&"
import script from "./ArchivoPacienteDetalles.vue?vue&type=script&lang=js&"
export * from "./ArchivoPacienteDetalles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports